import { Link } from 'gatsby';
import React, { useState } from 'react';
import clsx from 'clsx';

import * as styles from './Nav.module.scss';
import Subnav from './Subnav';
import OutsideAlerter from '../OutsideAlerter/OutsideAlerter';

export default function Nav(){
  const [active, setActive] = useState('');

  const menu = [
    {
      id: 'about',
      text: 'About',
      href: null,
      items: [
        {
          id: 'mission',
          text: 'Our Mission',
          href: '/mission'
        },
        {
          id: 'history',
          text: 'Our History',
          href: '/history'
        },
        {
          id: 'team',
          text: 'Our Team',
          href: '/leadership'
        }/*,
        {
          id: 'contact',
          text: 'Contact Us',
          href: '/contact'
        }*/
      ]
    },
    {
      id: 'neuroplastogen',
      text: 'Neuroplastogen Engine',
      href: null,
      items: [
        {
          id: 'science',
          text: 'Science of Neuroplastogens',
          href: '/science'
        },
        {
          id: 'psychoplastogens',
          text: 'Power of Neuroplastogens',
          href: '/neuroplastogens'
        },
        {
          id: 'publications',
          text: 'Publications',
          href: '/publications'
        }
      ]
    },
    {
      id: 'pipeline',
      text: 'Pipeline',
      href: '/pipeline',
      items: null
    },
    {
      id: 'investors',
      text: 'Investors & Media',
      href: null,
      items: [
        {
          id: 'news',
          text: 'Latest News',
          href: '/news'
        },
        {
          id: 'investors',
          text: 'For Investors',
          href: '/investors'
        },
      ]
    },
  ];

  const onClickHandler = (item) => {
    setActive(item);
  };

  const onClickOutside = () => {
    setActive('');
  };

  return (
    <section className={styles.nav}>
      <div className={styles.scroll}>
        <div className={styles.wrapper}>
            {
              menu.map(item => {
                if(item.items !== null) {
                  return(
                    <OutsideAlerter key={item.id} callback={onClickOutside}>
                    <div className={clsx(styles.item, item.items !== null, active === item.id && styles.active)}
                    >
                      <button className={clsx(styles.itemText, styles.haveItems)}
                        onClick={()=> {onClickHandler(item.id)}}>{item.text}</button>
                      <Subnav key={`${item.id}-subnav`} items={item.items}/>
                    </div>
                    </OutsideAlerter>
                  )
                } else {
                  return(<div key={item.id} ><Link to={item.href} className={styles.item} activeClassName={styles.active}>
                    <span className={styles.itemText}>{item.text}</span>
                  </Link></div>)
                }
              })
            }
        </div>
      </div>
    </section>
  )
}
